import { useMemo } from 'react';
import { object, string } from 'yup';

export function useCommentSchema() {
    return useMemo(
        () =>
            object().shape({
                message: string().required(),
                type: string().required(),
            }),
        [],
    );
}
